export default __webpack_public_path__ + "static/media/Montserrat-Regular.317b418e.ttf";